export default __webpack_public_path__ + "static/media/10.aaa2f5a8.png";